import { ApiResponse, fetchApi } from './common';
import { User } from './model';

// 注册请求接口
export interface RegisterRequest {
  name: string;
  phone_number: string;
  username: string;
  password_hash: string;
  user_type: string;
}

// 注册响应接口
export interface RegisterResponse {
  user_id: string;
  name: string;
  username: string;
}

// 登录请求接口
export interface LoginRequest {
  user_type: string;
  username: string;
  password_hash: string;
}

// 登录响应接口
export interface LoginResponse {
  username: string;
  user: User;
}

// 医生资料接口
export interface DoctorProfile {
  user_id: string;
  name: string;
  title?: string;
  user_type: string;
}

// 更新资料请求接口
export interface UpdateProfileRequest {
  name?: string;
  title?: string;
  gender?: string;
  birth_date?: string;
}

// 更新医生资料请求接口
export interface UpdateDoctorProfileRequest {
  name?: string;
  title?: string;
}

// 检查微信绑定状态响应接口
export interface CheckWechatBindingResponse {
  is_bound: boolean;
  app_id?: string;
}

// 修改密码请求接口
export interface ChangePasswordRequest {
  old_password_hash: string;
  new_password_hash: string;
}

// 用户API请求函数
export const userApi = {
  // 用户注册
  register: async (data: RegisterRequest): Promise<ApiResponse<RegisterResponse>> => fetchApi<RegisterResponse>('/api/users/register', 'POST', data),

  // 用户登录
  login: async (data: LoginRequest): Promise<ApiResponse<LoginResponse>> => fetchApi<LoginResponse>('/api/users/login', 'POST', data),

  // 用户登出
  logout: async (): Promise<ApiResponse<null>> => fetchApi<null>('/api/users/logout', 'POST'),

  // 获取医生资料
  getDoctorProfile: async (): Promise<ApiResponse<DoctorProfile>> => fetchApi<DoctorProfile>('/api/doctor_view/profile', 'GET'),

  // 更新医生资料
  updateDoctorProfile: async (data: UpdateDoctorProfileRequest): Promise<ApiResponse<DoctorProfile>> => fetchApi<DoctorProfile>('/api/doctor_view/profile', 'PUT', data),

  // 检查会话状态
  checkSession: async (): Promise<boolean> => {
    try {
      const response = await fetch('/api/users/check-session', {
        method: 'GET',
        credentials: 'include'
      });
      return response.ok;
    } catch (error) {
      return false;
    }
  },

  // 检查微信绑定状态
  checkWechatBinding: async (): Promise<ApiResponse<CheckWechatBindingResponse>> => {
    return fetchApi<CheckWechatBindingResponse>('/api/users/check-wechat-binding', 'GET');
  },

  // 修改密码
  changePassword: async (data: ChangePasswordRequest): Promise<ApiResponse<null>> => {
    return fetchApi<null>('/api/users/change-password', 'POST', data);
  }
};